// src/pages/admin/components/AuditLogDialog.tsx
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { ReactElement, useState } from 'react';
import { List, useTranslate } from 'react-admin';
import { EmptyContent } from 'src/components/empty-content/empty-content';
import AuditLogTable from './AuditLogTable';

interface AuditLogDialogProps {
  open: boolean;
  onClose: () => void;
  resource: string;
  recordId?: string;
  title?: string;
}

const transformResource = (resource: string): string => {
  return resource.replace(/\//g, '-');
};

const AuditLogDialog = ({ open, onClose, resource, recordId, title }: AuditLogDialogProps) => {
  const translate = useTranslate();
  const transformedResource = transformResource(resource);
  const resourceLink = recordId ? `audit-logs/${transformedResource}/${recordId}` : `audit-logs/${transformedResource}`;
  const [popup, setPopup] = useState<ReactElement>();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>{title || translate('resource.auditLogs')}</DialogTitle>
      <DialogContent>
        <List
          resource={resourceLink}
          title={title || translate('resource.auditLogs')}
          empty={<EmptyContent />}
          perPage={10}
          disableSyncWithLocation
          exporter={false}
        >
          <AuditLogTable showId showOldData showNewData />
        </List>
      </DialogContent>
      <Dialog open={Boolean(popup)} onClose={() => setPopup(undefined)} maxWidth="sm" fullWidth>
        {popup}
      </Dialog>
    </Dialog>
  );
};

export default AuditLogDialog;
